import React, { useMemo } from "react";
import {
  Checkbox,
  Form,
  Input,
  Option,
  Select,
  SingleSelect,
} from "../../../../_core/_components";
import { EditConfiguracaoComunicadoProperty } from "./reducer";
import { mascaraNumeros } from "../../../../_core/masks";

type Props = {
  arrCanal: Option[];
  arrTipoDivida: Option[];
  arrTipoComunicado: Option[];
  arrShoppings: Option[];
  form: any;
  dispatch: React.Dispatch<{
    type: EditConfiguracaoComunicadoProperty;
    payload: any;
  }>;
};

const ModalContent: React.FC<Props> = ({
  arrCanal,
  arrTipoDivida,
  arrTipoComunicado,
  arrShoppings,
  form,
  dispatch,
}: Props) => {
  return (
    <Form
      items={[
        <Input
          state={[
            form.descricaoComunicado,
            (value: React.SetStateAction<string>) =>
              dispatch({ type: "SET_DESCRICAO", payload: value }),
          ]}
          label="Descrição"
        />,
        <Input
          state={[
            form.quantidadeMinimaBoletos.toString(),
            (value: React.SetStateAction<string>) =>
              dispatch({ type: "SET_BOLETOS", payload: Number(value) }),
          ]}
          label="Quantidade mínima de boletos"
          pattern={mascaraNumeros}
        />,
        <Input
          state={[
            form.parametroVencimento,
            (value: React.SetStateAction<string>) =>
              dispatch({ type: "SET_VENCIMENTO", payload: value }),
          ]}
          label="Quantidade mínima de dias em aberto"
        />,
        <Input
          state={[
            form.nomeArquivo,
            (value: React.SetStateAction<string>) =>
              dispatch({ type: "SET_NOME_ARQUIVO", payload: value }),
          ]}
          label="Nome do arquivo"
        />,
        <SingleSelect
          state={[
            arrCanal.find((e) => e.value === form.idCanal),
            (option: Option) =>
              dispatch({ type: "SET_TIPO_CANAL", payload: option?.value }),
          ]}
          options={arrCanal}
          placeholder="Canal"
        />,
        <SingleSelect
          state={[
            arrTipoDivida.find((e) => e.value === form.idTipoDivida),
            (option: Option) =>
              dispatch({ type: "SET_TIPO_DIVIDA", payload: option?.value }),
          ]}
          options={arrTipoDivida}
          placeholder="Tipo dívida"
        />,
        <SingleSelect
          state={[
            arrTipoComunicado.find((e) => e.value === form.idTipoComunicado),
            (option: Option) =>
              dispatch({ type: "SET_TIPO_COMUNICADO", payload: option?.value }),
          ]}
          options={arrTipoComunicado}
          placeholder="Tipo comunicado"
        />,
        <Select
          state={[
            form.shoppings,
            (options) => dispatch({ type: "SET_SHOPPINGS", payload: options }),
          ]}
          options={arrShoppings}
          placeholder="Shoppings"
        />,
        null,
        <Checkbox
          label="Ativo"
          checked={form.flagAtivo}
          onClick={() =>
            dispatch({ type: "SET_ATIVO", payload: !form.flagAtivo })
          }
        />,
        <Checkbox
          label="Dados Fiador"
          checked={form.flagDadosFiador}
          onClick={() =>
            dispatch({
              type: "SET_DADOS_FIADOR_ATIVO",
              payload: !form.flagDadosFiador,
            })
          }
        />,
      ]}
    />
  );
};

export default ModalContent;
